// ArChat Auto-Normalized File
// Created: 12-03-2026 22:38:36
// Author: SIVOL® - Aldo Frias - Argentina

/**
 * Autor: SIVOL® - Aldo Frias - Argentina
 * Fecha: 11/03/2026 22:50 (Argentina - UTC-3)
 * @file PreloaderOverlay.jsx
 * @description Overlay de carga global para operaciones async (reenvío de invitación, etc.)
 */

import { useLanguage } from '../../context/LanguageContext';
import './PreloaderOverlay.css';

/**
 * @param {boolean} visible - Si el overlay está visible
 * @param {string} [message] - Mensaje bajo el spinner (opcional, por defecto t('system.processing'))
 */
function PreloaderOverlay({ visible, message }) {
  const { t } = useLanguage();
  const text = message != null && message !== '' ? message : t('system.processing');

  if (!visible) return null;

  return (
    <div className="preloader-overlay" role="status" aria-live="polite" aria-busy="true">
      <div className="preloader-overlay-backdrop" />
      <div className="preloader-overlay-content">
        <div className="preloader-overlay-spinner" aria-hidden="true" />
        <p className="preloader-overlay-text">{text}</p>
      </div>
    </div>
  );
}

export default PreloaderOverlay;
